import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

type Links = {
  linkTitle: string;
  linkRoute: string;
};

const LPFooterColumn = ({
  title,
  links,
  className,
  isAnchor = false
}: {
  title: string;
  links: Array<Links>;
  className?: string;
  isAnchor?: boolean;
}) => (
  <div className={classnames("col-12 col-lg-6 col-xl-3 p-5", className)}>
    <h3 className="h6 mb-3">{title}</h3>
    <ul className="nav flex-column">
      {links?.map((link, index) => (
        <li key={`${index}${link.linkTitle}`} className="nav-item">
          {isAnchor ? (
            <a
              aria-current="page"
              className="nav-link link-secondary ps-0"
              href={link.linkRoute}
              rel="noreferrer"
              target="_blank">
              {link.linkTitle}
            </a>
          ) : (
            <Link aria-current="page" className="nav-link link-secondary ps-0" to={link.linkRoute}>
              {link.linkTitle}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export default LPFooterColumn;
